// extracted by mini-css-extract-plugin
module.exports = {"h2":"style_h2__3hYUC","instruction":"style_instruction__2Xntk","checkbox__div":"style_checkbox__div__1_BuI","submit__btn":"style_submit__btn__1Hstf"};